var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { key: _vm.renderId, staticClass: "random-message" }, [
    _c("div", { staticClass: "header-content" }, [
      _c("span", { staticClass: "label" }, [_vm._v("Variants")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "numbers" },
        [
          _vm._l(_vm.texts, function (_, textIndex) {
            return _c(
              "div",
              {
                key: "number-" + textIndex,
                staticClass: "number",
                class: { active: textIndex === _vm.currentIndex },
                on: {
                  click: function ($event) {
                    _vm.currentIndex = textIndex
                  },
                },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(textIndex + 1) +
                    "\n            "
                ),
              ]
            )
          }),
          _vm._v(" "),
          !_vm.previewMode
            ? _c(
                "div",
                { staticClass: "number", on: { click: _vm.addNewMessage } },
                [_vm._v("+")]
              )
            : _vm._e(),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        key: _vm.stateId + "-" + _vm.currentIndex,
        staticClass: "message-content",
      },
      [
        _vm.texts.length > 2 && !_vm.previewMode
          ? _c(
              "button",
              {
                staticClass: "control-button",
                on: {
                  click: function ($event) {
                    return _vm.deleteMessage(_vm.currentIndex)
                  },
                },
              },
              [
                _c("md-icon", { staticClass: "text-primary" }, [
                  _vm._v("delete"),
                ]),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("TiptapEditor", {
          key: _vm.stateId + "-" + _vm.currentIndex,
          attrs: {
            placeholder: _vm.$t("chatbotv2.enterBotResponseHere"),
            "show-attributes": _vm.showAttributes,
            "show-emoji": _vm.showEmoji,
            "whatsapp-mode": _vm.whatsappMode,
            "allowed-attributes": _vm.allowedAttributes,
          },
          model: {
            value: _vm.texts[_vm.currentIndex],
            callback: function ($$v) {
              _vm.$set(_vm.texts, _vm.currentIndex, $$v)
            },
            expression: "texts[currentIndex]",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }